const en_dashboard = {
    search: { title: "Search", placeholder: "Company ID" },
}

export default en_dashboard;